import React from 'react';

const IncomeCertificateDocument = ({ data, componentRef }) => {
  if (!data) return null;

  return (
    <div>
      <div ref={componentRef} className="p-8 bg-white text-black font-poppins" style={{ width: '210mm', minHeight: '297mm' }}>
        
        {/* Header */}
        <div className="text-center mb-8 border-b-2 border-black pb-4">
            <h1 className="text-2xl font-bold mb-2">ग्रामपंचायत कार्यालय, इनाम धामणी</h1>
            <p className="text-sm">ता. मिरज, जि. सांगली</p>
            <h2 className="text-xl font-bold mt-4 underline">उत्पन्नाचा दाखला</h2>
        </div>

        {/* Content */}
        <div className="space-y-6 text-lg leading-relaxed">
            <div className="flex justify-between">
                <span><strong>जावक क्र.:</strong> {data.outwardNo || '-'}</span>
                <span><strong>दिनांक:</strong> {new Date(data.receiptDate || data.certificateDate).toLocaleDateString('en-IN')}</span>
            </div>
            
            <div className="flex justify-between mt-2">
                <span><strong>दाखला क्रमांक:</strong> {data.certificateNo}</span>
            </div>

            <p className="mt-8 text-justify">
                दाखला देण्यात येतो की, <strong>{data.personName}</strong> 
                (राहणार इनाम धामणी, ता. मिरज, जि. सांगली) यांना हे ओळखतात. 
                त्यांनी सादर केलेल्या माहितीनुसार व पुराव्यानुसार त्यांचे सन <strong>{data.financialYear}</strong> 
                मधील सर्व मार्गानी मिळून येणारे वार्षिक उत्पन्न सुमारे <strong>रु. {data.annualIncome}/-</strong> 
                (अक्षरी रुपये {data.annualIncomeInWords || '-'}) आहे.
            </p>

            <p className="mt-4">
                सदरचा दाखला हा त्यांना शैक्षणिक / शासकीय कामासाठी मागणी केल्यावरून देण्यात येत आहे.
            </p>
        </div>

        {/* Footer */}
        <div className="mt-32 flex justify-between items-end">
            <div className="text-center">
                <p>ठिकाण: इनाम धामणी</p>
                <p>दिनांक: {new Date().toLocaleDateString('en-IN')}</p>
            </div>
            <div className="text-center">
                <p className="font-bold">सरपंच / ग्रामसेवक</p>
                <p>ग्रामपंचायत कार्यालय</p>
                <p>इनाम धामणी</p>
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default IncomeCertificateDocument;
